import { render, staticRenderFns } from "./simulation.vue?vue&type=template&id=f9701862"
import script from "./simulation.vue?vue&type=script&lang=js"
export * from "./simulation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports